import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=b20cbc7c&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b20cbc7c')) {
      api.createRecord('b20cbc7c', component.options)
    } else {
      api.reload('b20cbc7c', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=b20cbc7c&", function () {
      api.rerender('b20cbc7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2kvPBXCEXBZjc/JS/imageCarousel.vue"
export default component.exports